<template>
	<div id="home">
		<div class="hero-slider">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="hero-slider-content">
							<h1 class="hero-title">
								fresh
								<span class="title-span">halal & hygenic</span>
								food
							</h1>
							<p>
								We are an Australian-inspired steakhouse
								restaurant beloved worldwide. We pride ourselves
								on serving up variety; our unbeatable steak cuts
								are complemented by delicious choices of
								chicken, ribs, seafood, and pasta at a price for
								everyone
							</p>
							<a
								v-scroll-to="'#reservation'"
								data-scroll
								class="btn btn-custom btn-primary-border"
								>order now</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Hero",
	};
</script>
